import {useCallback, useEffect, useRef} from 'react';

export const useEscpacePress = (
  onEscpacePress?: (e: KeyboardEvent) => void
) => {
  const onKeypress = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape' || e.key === 'Esc') {
        onEscpacePress?.(e);
      }
    },
    [onEscpacePress]
  );

  useEffect(() => {
    if (onEscpacePress) {
      document.addEventListener('keydown', onKeypress);
    } else {
      document.removeEventListener('keydown', onKeypress);
    }

    return () => {
      document.removeEventListener('keydown', onKeypress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onEscpacePress]);
};

export const useWhyDidYouUpdate = (name: string, props: any) => {
  const previousProps = useRef<typeof props>();

  useEffect(() => {
    if (previousProps.current) {
      const allKeys = Object.keys({...previousProps.current, ...props});
      const changesObj: any = {};
      allKeys.forEach((key) => {
        if (previousProps.current[key] !== props[key]) {
          changesObj[key] = {
            from: previousProps.current[key],
            to: props[key],
          };
        }
      });

      if (Object.keys(changesObj).length) {
        console.log('[why-did-you-update]', name, changesObj);
      }
    }

    previousProps.current = props;
  });
};
